import React from "react";

import SvgDotsHorizontal from "@uui/DotsHorizontal";

import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import IconButton from "@rui/IconButton";
import Menu from "@rui/Menu";
import MenuItem from "@rui/MenuItem";

type OptionId = "ignoreAll" | "acceptAll";
// TODO: ENG 8466 Add "Show all reports for this meeting" button
const OPTIONS: { id: OptionId; label: string }[] = [
  { id: "ignoreAll", label: "Ignore all" },
  { id: "acceptAll", label: "Accept and acknowledge all" },
];

const RecommendationActionsDropdownMenu = ({
  onAcceptAll,
  onRejectAll,
}: {
  onAcceptAll: () => void;
  onRejectAll: () => void;
}) => {
  const { anchorElement, open, onClick, onClose } = useAnchorElement();

  const handleClick = (id: OptionId) => {
    if (id === "acceptAll") {
      onAcceptAll();
    } else {
      onRejectAll();
    }
    onClose();
  };

  return (
    <>
      <IconButton onClick={onClick} size="small">
        <SvgDotsHorizontal />
      </IconButton>
      <Menu
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
        onClose={onClose}
        anchorEl={anchorElement}
        open={open}
      >
        {OPTIONS.map((option) => (
          <MenuItem key={option.id} onClick={() => handleClick(option.id)}>
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default RecommendationActionsDropdownMenu;
